export class ConfirmModal {

    //#region ModalHtml 

    private modalHtml =
        `<div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modal-title-field"></h5>
                </div>
                <div class="modal-body" id="modal-body-message">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary"  id="modal-cancel-button"></button>
                    <button type="button" class="btn btn-primary" id="modal-confirm-button"></button>
                </div>
            </div>
        </div>`;

    //#endregion

    constructor() {
        this.modalContainer = $(document.createElement("div"));
        this.modalContainer.addClass('modal');
        this.modalContainer.attr('id', 'custom-confirm-dialog-modal');
        this.modalContainer.attr('role', 'dialog');

        this.modalContainer.html(this.modalHtml);

        $('body').append(this.modalContainer);
    }

    private modalContainer;

    public initialize(title: string,
        message: string,
        confirmFunction: () => void,
        cancelFunction?: () => void,
        confirmButtonText?: string,
        cancelButtonText?: string) {

        var closeModal = () => {
            this.modalContainer.modal('hide');
            this.modalContainer.remove();
        }

        var titleField = this.modalContainer.find('#modal-title-field');
        var messageField = this.modalContainer.find('#modal-body-message');

        titleField.text(title);
        messageField.html(message);

        var confirmButton = this.modalContainer.find('#modal-confirm-button');
        if (confirmButtonText) {
            confirmButton.text(confirmButtonText);
        }

        var cancelButton = this.modalContainer.find('#modal-cancel-button');
        if (cancelButtonText) {
            cancelButton.text(cancelButtonText);
        }

        confirmButton.unbind().one('click', confirmFunction).one('click', closeModal);

        if (cancelFunction) {
            cancelButton.unbind().one('click', cancelFunction).one('click', closeModal);
        } else {
            cancelButton.unbind().one('click', closeModal);
        }

        this.modalContainer.modal({
            backdrop: 'static',
            keyboard: false,
            focus: true
        });

        this.modalContainer.modal('show');
    }
}